<div class="release-notes-link">
  <a target="_blank" [href]="releaseNotesLink"
    ><span>{{ 'ReleaseDialog.DetailedNotes' | translate }}</span>
  </a>
  <a class="release-notes-link__icon" target="_blank" [href]="releaseNotesLink"
    ><span class="dv-icons">exit_to_app</span></a
  >
</div>
